export default {
  table_ordering: 'Commande à table',
  table: 'Table',
  pickup_or_delivery: 'À emporter ou livraison',
  asap: 'Dès que possible',
  served_in: 'Servie dans {{time}} min',
  not_taking_orders: 'Commandes suspendues',
  not_your_table: 'Ce n’est pas votre table ? Scannez le code sur la vôtre.',
  eating_here: {
    title: 'Vous mangez sur place ?',
    back_to_table: 'Commandez pour {{table}}. Nous vous l’apporterons.',
    scan_code: 'Scannez le QR code sur votre table pour commander.',
  },
  notes: {
    table_unavailable: {
      title: 'Le QR code de cette table ne fonctionne plus.',
      text: 'Demandez au personnel. Vous pouvez toujours commander à emporter.',
      text_no_pickup: 'Demandez au personnel.',
    },
    table_ordering_off: {
      title: 'La commande à table n’est pas disponible pour le moment.',
      text: 'Vous pouvez commander à emporter à la place.',
    },
    load_failed: {
      title: 'Impossible de charger ta table.',
      text: 'Scanne à nouveau le QR code.',
    },
    closed: {
      title: 'Fermé pour le moment.',
      text: 'Vous pouvez commander à votre table à partir de {{time}}.',
      text_later: 'Vous pourrez commander à votre table dès notre réouverture.',
    },
    paused: {
      title: 'Nous ne prenons pas de commandes pour le moment.',
      text: 'Demandez au personnel ou réessayez dans quelques minutes.',
    },
  },
  cart: {
    closed:
      'Fermé actuellement. Vous pouvez commander à votre table à partir de {{time}}. Votre panier est conservé jusque-là.',
    closed_later: 'Fermé actuellement. Votre panier est conservé jusqu’à notre réouverture.',
    paused: 'Nous ne prenons pas de commandes pour le moment. Votre panier est conservé. Demandez au personnel.',
  },
  cash_note: 'Payez en espèces au comptoir.',
  confirmation: {
    bring_to_table: 'Nous apporterons votre commande à votre table.',
    your_table: 'Votre table',
    moved_table:
      'Vous avez changé de table ? Indiquez au personnel votre numéro de commande <strong>{{number}}</strong>.',
  },
  served: 'Servie',
};
